import { Box, Spinner } from "@chakra-ui/react";

import { useAppStore } from "../context/store";

function Loading() {
  const showLoadingMap = useAppStore((s) => s.showLoadingMap);

  if (!showLoadingMap) return null;

  return (
    <Box
      width="100vw"
      height="100vh"
      m={0}
      p={0}
      display="flex"
      alignItems="center"
      justifyContent="center"
      position="absolute"
      top={0}
      left={0}
      right={0}
      zIndex={1000}
      bg="blackAlpha.400"
      backdropFilter="blur(1px)"
    >
      <Spinner color="white" size="lg" />
    </Box>
  );
}

export default Loading;
